
import React from 'react';

const PublicOffering = () => {
  return (
    <div>
      <h2 className="text-4xl font-bold text-black mb-5">
   Product And Service<span className="text-[#680099] ml-2 font-bold">Offering</span>
</h2>
<h5 className="text-xl font-bold text-black mb-1 mt-4"> Travel Packages</h5>
      <ul style={bulletPointsStyle}>
        <li style={bulletPointItemStyle}> <strong>Coverage: </strong> Offering access to popular and niche destinations across 10 countries</li>
        <li style={bulletPointItemStyle}> <strong>Customization: </strong> Real-time itinerary adjustments through Strategic Partners API provide agents with flexible, competitive pricing.</li>
      </ul>

        <br />
        <br />

    
        <h5 className="text-xl font-bold text-black mb-1 mt-4"> Forex Services</h5>
        {/* Bullet points list for Identified Market Gaps */}
      <ul style={bulletPointsStyle}>
        <li style={bulletPointItemStyle}> <strong>Pending FFMC License: </strong> Upon approval, Vigovia will add currency exchange, providing an integrated travel and forex solution to agents and direct consumers.</li>
       
      </ul>
    </div>
  );
};

const bulletPointsStyle = {
    listStyleType: 'disc',  // Bullet points (disc)
    paddingLeft: '20px',    // Indentation for the list
    marginTop: '20px',      // Space above the list
  };
  
  const bulletPointItemStyle = {
    fontSize: '19px',       // Font size for the bullet point text
    marginBottom: '10px',   // Space between each bullet point
    lineHeight: '1.6',      // Line height for readability
  };
  

export default PublicOffering;
